import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createUserTenantConnection, fetchTenantInvoiceDetails, fetchUserTenantConnections, removeUserTenantConnection, updateUserTenantConnection } from "../app/actions";

import { Button, Table } from "react-bootstrap"
import AddEditUserTenantConnectionModal from "./AddEditUserTenantConnectionModal";

import { Link } from "react-router-dom"


const UserTenantConnections = ({tenant, user}) => {
    const [editUserTenantConnection, setEditUserTenantConnection] = useState(null)
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const userTenantConnections = useSelector(store => store.app.userTenantConnections);
    const dispatch = useDispatch();
    useEffect(()=>{
        loadUserTenantConnections()
    }, [])

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const loadUserTenantConnections = () => {
        dispatch(fetchUserTenantConnections(1, { TenantID: tenant, UserID: user }))
        if(tenant) {
            dispatch(fetchTenantInvoiceDetails(tenant))
        }
    }

    const handleDelete = (userTenantConnection) => {
        if(userTenantConnection.id) {
            dispatch(removeUserTenantConnection(userTenantConnection.id))
                .then(()=>{
                    loadUserTenantConnections()
                    setShowAddEditModal(false)
                })
        }
    }

    const handleSave = (userTenantConnection) => {
        if(userTenantConnection.id) {
            dispatch(updateUserTenantConnection(
                userTenantConnection.id,
                userTenantConnection.TenantID,
                userTenantConnection.UserID,
                userTenantConnection.TenantRole,
                userTenantConnection.TenantEmployeeID
            )).then(()=>{
                loadUserTenantConnections()
                setShowAddEditModal(false)
            })
        } else {
            dispatch(createUserTenantConnection(
                userTenantConnection.TenantID,
                userTenantConnection.UserID,
                userTenantConnection.TenantRole,
                userTenantConnection.TenantEmployeeID
            )).then(()=>{
                loadUserTenantConnections()
                setShowAddEditModal(false)
            })
        }
    }
    
    return <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            {tenant ? <h5>Users</h5> : user ? <h5>Tenants</h5> :  <h2>User tenant connections</h2>}
            <Button onClick={()=>{
                setEditUserTenantConnection(null);
                setShowAddEditModal(true);
            }}>
                {tenant ? "Add users" : user ? "Add tenant" :  "Create user tenant connections"}
            </Button>
        </div>
        <br/>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    {!user && <th>User</th>}
                    {!tenant && <th>Tenant</th>}
                    <th>Tenant Role</th>
                    <th>Tenant Employee ID</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {userTenantConnections && userTenantConnections.map(userTenantConnection => {
                    return <tr key={userTenantConnection.id} onClick={()=>{
                        setShowAddEditModal(true)
                        setEditUserTenantConnection(userTenantConnection)
                    }}>
                        <td>{userTenantConnection.id}</td>
                        {!user && <td onClick={(e) => { e.stopPropagation() }}>
                            <Link to={"/users/" + userTenantConnection.UserID}>#{userTenantConnection.UserID} {userTenantConnection.UserFirstName} {userTenantConnection.UserLastName}</Link>
                        </td>}
                        {!tenant && <td>
                            <Link to={"/tenants/" + userTenantConnection.TenantID}>#{userTenantConnection.TenantID} {userTenantConnection.TenantShortName}</Link>
                        </td>}
                        <td>{userTenantConnection.TenantRole}</td>
                        <td>{userTenantConnection.TenantEmployeeID}</td>
                        <td>{userTenantConnection.updated_at}</td>
                        <td>{userTenantConnection.created_at}</td>
                    </tr>
                })}
                
            </tbody>
        </Table>
        <AddEditUserTenantConnectionModal user={user} tenant={tenant} editUserTenantConnection={editUserTenantConnection} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleSave} onDelete={handleDelete}/>
    </div>
} 

export default UserTenantConnections